import React, { forwardRef, Ref, SVGAttributes } from 'react';
import styled, { AnyStyledComponent } from 'styled-components';

interface Props extends SVGAttributes<SVGSVGElement> {
  color?: string;
  icon:
    | AnyStyledComponent
    | React.ForwardRefExoticComponent<
        React.SVGAttributes<SVGSVGElement> & React.RefAttributes<SVGSVGElement>
      >;
}
export const StyledIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => {
  const ThemedIcon = styled(props.icon)`
    circle {
      fill: ${({ theme, color }) => (color ? color : theme.additions.icons.color1)};
    }
    path {
      fill: ${({ theme, color }) => (color ? color : theme.additions.icons.color1)};
    }
  `;
  return <ThemedIcon ref={ref} {...props} />;
});
